import React, { useState, useEffect } from "react";



import { useNavigate, Link, useParams, } from 'react-router-dom';
import Swal from 'sweetalert2'
import db from "./Firebase";
import { storage } from './Firebase';

import { collection, getDocs, setDoc, doc, addDoc } from "firebase/firestore";
import Moment from 'moment';
import { extendMoment } from 'moment-range';

function QuizManager() {
    const navigate = useNavigate();
    const [quizzes, setQuizzes] = useState([]);
    const [quizId, setQuizId] = useState("");
    const [quizData, setQuizData] = useState([
        { question: "", answers: ["", "", "", ""], correctAnswer: 0 },

    ]);
    const [editingQuiz, setEditingQuiz] = useState(null);
    const [email, setEmail] = useState("");



    useEffect(() => {
        const storedUsername = localStorage.getItem("email");
        const storedPassword = localStorage.getItem("password");
        const storedRemember = localStorage.getItem("remember");

        setEmail(storedUsername)

        if (storedRemember === "false" || !storedUsername || !storedPassword) {
            navigate('/signin');
        }

    }, []);

    // Fetch quizzes from Firestore
    useEffect(() => {
        const fetchQuizzes = async () => {
            const snapshot = await getDocs(collection(db, "nv_quiz_data"));
            let quizList = [];
            snapshot.forEach((doc) => {
                quizList.push({ id: doc.id, ...doc.data() });
            });
            setQuizzes(quizList);
        };
        fetchQuizzes();
    }, []);

    // Handle input changes
    const handleQuestionChange = (index, value) => {
        const updated = [...quizData];
        updated[index].question = value;
        setQuizData(updated);
    };

    const handleAnswerChange = (qIndex, aIndex, value) => {
        const updated = [...quizData];
        updated[qIndex].answers[aIndex] = value;
        setQuizData(updated);
    };

    const handleCorrectAnswerChange = (index, value) => {
        const updated = [...quizData];
        updated[index].correctAnswer = parseInt(value);
        setQuizData(updated);
    };

    // Add new question
    const addQuestion = () => {
        setQuizData([...quizData, { question: "", answers: ["", "", "", ""], correctAnswer: 0 }]);
    };

    // Save or update quiz
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!quizId.trim()) {
            alert("Please enter a Quiz ID.");
            return;
        }

        const formattedData = { questions: quizData };

        try {
            await setDoc(doc(db, "nv_quiz_data", quizId), formattedData);
            alert("Quiz saved successfully!");
            setQuizzes([...quizzes, { id: quizId, ...formattedData }]);
            resetForm();
        } catch (error) {
            console.error("Error saving quiz:", error);
            alert("Failed to save quiz.");
        }

        // ✅ Add log entry in "nv_backend_logs"
        const logEntry = {
            created_date: new Date(), // Current timestamp
            email: email || "unknown", // Fallback if email is missing
            page: "AddQuiz",
            action: `Added Quiz ID: ${quizId} for enrolled, quiz data is: ${formattedData}`,
        };

        await addDoc(collection(db, "nv_backend_logs"), logEntry);
        console.log("Log entry added:", logEntry);
    };

    // Edit quiz
    const editQuiz = (quiz) => {
        setQuizId(quiz.id);
        setQuizData(quiz.questions);
        setEditingQuiz(quiz.id);
    };

    // Reset form
    const resetForm = () => {
        setQuizId("");
        setQuizData([{ question: "", answers: ["", "", "", ""], correctAnswer: 0 }]);
        setEditingQuiz(null);
    };



    return (
        <>
            <div class="p-2" style={{ paddingBottom: "5px", display: "flex", justifyContent: "space-between" }}>
                {/* <span class="btn bg-gradient-secondary btn-sm mb-0 mr-2" style={{ color: "white" }} >&nbsp; Download Excel</span> */}
                <Link to="/"><img src="/images/menubutton.png" class="menu-toggle" alt="Responsive image" style={{ height: "2rem" }} /></Link>

            </div>

            <div class="p-3">

                <div class="card-header pb-0 px-3">
                    <h6 class="mb-2">Quiz Manager</h6>
                </div>



                <div class="table-responsive fix-width scroll-inner">
                    <table class="table table-bordered table-hover">
                        <thead class="thead-dark" style={{ position: "sticky", top: "0" }}>
                            <tr>
                                <th className="border p-2">Quiz ID</th>
                                <th className="border p-2">Questions</th>
                                <th className="border p-2">Actions</th>
                            </tr>
                        </thead>
                        <tbody>

                            {quizzes.map((quiz) => (
                                <tr key={quiz.id} className="hover:bg-gray-100">
                                    <td className="border p-2">{quiz.id}</td>
                                    <td className="border p-2">{quiz.questions.length} Questions</td>
                                    <td className="border p-2">
                                        <button
                                            className="bg-blue-500 text-white px-3 py-1 rounded mr-2"
                                            onClick={() => editQuiz(quiz)}
                                        >
                                            Edit
                                        </button>
                                    </td>
                                </tr>
                            ))}

                        </tbody>
                    </table>
                    <hr style={{ height: "2px", borderWidth: "0", color: "#dc3545", backgroundColor: "#dc3545" }} />

                    {/* Add/Edit Quiz Form */}
                    <form onSubmit={handleSubmit} className="bg-white shadow p-4 rounded">
                        <label className="block font-semibold mb-2">Quiz ID:</label>
                        <input
                            type="text"
                            value={quizId}
                            onChange={(e) => setQuizId(e.target.value)}
                            required
                            placeholder="Enter Quiz ID (e.g., 01, 02, q1, q2...)"
                            className="w-full border p-2 rounded mb-4"
                            disabled={editingQuiz}
                        />

                        {quizData.map((quiz, qIndex) => (
                            <div key={qIndex} className="mb-4 border p-3 rounded">
                                <label className="block font-semibold mb-1">Question {qIndex + 1}:</label>
                                <input
                                    type="text"
                                    value={quiz.question}
                                    onChange={(e) => handleQuestionChange(qIndex, e.target.value)}
                                    required
                                    className="w-full border p-2 rounded mb-2"
                                />
                                <label className="block font-semibold mb-1">Answers:</label>
                                {quiz.answers.map((answer, aIndex) => (
                                    <input
                                        key={aIndex}
                                        type="text"
                                        value={answer}
                                        onChange={(e) => handleAnswerChange(qIndex, aIndex, e.target.value)}
                                        required
                                        className="w-full border p-2 rounded mb-2"
                                        placeholder={`Option ${String.fromCharCode(65 + aIndex)}`}
                                    />
                                ))}
                                <label className="block font-semibold mb-1">Correct Answer (eg. 1, 2, 3, 4):</label>
                                <input
                                    type="number"
                                    value={quiz.correctAnswer + 1}
                                    onChange={(e) => handleCorrectAnswerChange(qIndex, parseInt(e.target.value) - 1)}
                                    required
                                    min="1"
                                    max="4"
                                    className="w-full border p-2 rounded"
                                />
                            </div>
                        ))}

                        <button
                            type="button"
                            onClick={addQuestion}
                            className="bg-green-500 text-white px-4 py-2 rounded mr-2"
                        >
                            Add Question
                        </button>
                        <button type="submit" className="bg-blue-500 text-white px-4 py-2 rounded">
                            {editingQuiz ? "Update Quiz" : "Save Quiz"}
                        </button>
                        {editingQuiz && (
                            <button
                                type="button"
                                onClick={resetForm}
                                className="bg-gray-500 text-white px-4 py-2 rounded ml-2"
                            >
                                Cancel
                            </button>
                        )}
                    </form>
                </div>


            </div>





        </>
    )
}

export default QuizManager



// import React, { useState, useEffect } from "react";



// import { collection, getDocs, setDoc, doc } from "firebase/firestore";
// import db from "./Firebase";

// const QuizManager = () => {
//     const [quizzes, setQuizzes] = useState([]);
//     const [quizId, setQuizId] = useState("");
//     const [quizData, setQuizData] = useState([
//         { question: "", answers: ["", "", "", ""], correctAnswer: 0 },
//     ]);
//     const [editingQuiz, setEditingQuiz] = useState(null);

//     // Fetch quizzes from Firestore
//     useEffect(() => {
//         const fetchQuizzes = async () => {
//             const snapshot = await getDocs(collection(db, "nv_quiz_data"));
//             let quizList = [];
//             snapshot.forEach((doc) => {
//                 quizList.push({ id: doc.id, ...doc.data() });
//             });
//             setQuizzes(quizList);
//         };
//         fetchQuizzes();
//     }, []);

//     // Handle input changes
//     const handleQuestionChange = (index, value) => {
//         const updated = [...quizData];
//         updated[index].question = value;
//         setQuizData(updated);
//     };

//     const handleAnswerChange = (qIndex, aIndex, value) => {
//         const updated = [...quizData];
//         updated[qIndex].answers[aIndex] = value;
//         setQuizData(updated);
//     };

//     const handleCorrectAnswerChange = (index, value) => {
//         const updated = [...quizData];
//         updated[index].correctAnswer = parseInt(value);
//         setQuizData(updated);
//     };

//     // Add new question
//     const addQuestion = () => {
//         setQuizData([...quizData, { question: "", answers: ["", "", "", ""], correctAnswer: 0 }]);
//     };

//     // Save or update quiz
//     const handleSubmit = async (e) => {
//         e.preventDefault();

//         if (!quizId.trim()) {
//             alert("Please enter a Quiz ID.");
//             return;
//         }

//         const formattedData = { questions: quizData };

//         try {
//             await setDoc(doc(db, "nv_quiz_data", quizId), formattedData);
//             alert("Quiz saved successfully!");
//             setQuizzes([...quizzes, { id: quizId, ...formattedData }]);
//             resetForm();
//         } catch (error) {
//             console.error("Error saving quiz:", error);
//             alert("Failed to save quiz.");
//         }
//     };

//     // Edit quiz
//     const editQuiz = (quiz) => {
//         setQuizId(quiz.id);
//         setQuizData(quiz.questions);
//         setEditingQuiz(quiz.id);
//     };

//     // Reset form
//     const resetForm = () => {
//         setQuizId("");
//         setQuizData([{ question: "", answers: ["", "", "", ""], correctAnswer: 0 }]);
//         setEditingQuiz(null);
//     };

//     return (
//         <div className="p-4 max-w-4xl mx-auto">
//             <h2 className="text-2xl font-bold mb-4">Quiz Manager</h2>

//             {/* Quiz Table */}
//             <table className="w-full border border-gray-300 mb-6">
//                 <thead className="bg-gray-200">
//                     <tr>
//                         <th className="border p-2">Quiz ID</th>
//                         <th className="border p-2">Questions</th>
//                         <th className="border p-2">Actions</th>
//                     </tr>
//                 </thead>
//                 <tbody>
//                     {quizzes.map((quiz) => (
//                         <tr key={quiz.id} className="hover:bg-gray-100">
//                             <td className="border p-2">{quiz.id}</td>
//                             <td className="border p-2">{quiz.questions.length} Questions</td>
//                             <td className="border p-2">
//                                 <button
//                                     className="bg-blue-500 text-white px-3 py-1 rounded mr-2"
//                                     onClick={() => editQuiz(quiz)}
//                                 >
//                                     Edit
//                                 </button>
//                             </td>
//                         </tr>
//                     ))}
//                 </tbody>
//             </table>

//             {/* Add/Edit Quiz Form */}
//             <form onSubmit={handleSubmit} className="bg-white shadow p-4 rounded">
//                 <label className="block font-semibold mb-2">Quiz ID:</label>
//                 <input
//                     type="text"
//                     value={quizId}
//                     onChange={(e) => setQuizId(e.target.value)}
//                     required
//                     placeholder="Enter Quiz ID (e.g., q1, q2...)"
//                     className="w-full border p-2 rounded mb-4"
//                     disabled={editingQuiz}
//                 />

//                 {quizData.map((quiz, qIndex) => (
//                     <div key={qIndex} className="mb-4 border p-3 rounded">
//                         <label className="block font-semibold mb-1">Question {qIndex + 1}:</label>
//                         <input
//                             type="text"
//                             value={quiz.question}
//                             onChange={(e) => handleQuestionChange(qIndex, e.target.value)}
//                             required
//                             className="w-full border p-2 rounded mb-2"
//                         />
//                         <label className="block font-semibold mb-1">Answers:</label>
//                         {quiz.answers.map((answer, aIndex) => (
//                             <input
//                                 key={aIndex}
//                                 type="text"
//                                 value={answer}
//                                 onChange={(e) => handleAnswerChange(qIndex, aIndex, e.target.value)}
//                                 required
//                                 className="w-full border p-2 rounded mb-2"
//                                 placeholder={`Option ${String.fromCharCode(65 + aIndex)}`}
//                             />
//                         ))}
//                         <label className="block font-semibold mb-1">Correct Answer:</label>
//                         <input
//                             type="number"
//                             value={quiz.correctAnswer + 1}
//                             onChange={(e) => handleCorrectAnswerChange(qIndex, parseInt(e.target.value) - 1)}
//                             required
//                             min="1"
//                             max="4"
//                             className="w-full border p-2 rounded"
//                         />
//                     </div>
//                 ))}

//                 <button
//                     type="button"
//                     onClick={addQuestion}
//                     className="bg-green-500 text-white px-4 py-2 rounded mr-2"
//                 >
//                     Add Question
//                 </button>
//                 <button type="submit" className="bg-blue-500 text-white px-4 py-2 rounded">
//                     {editingQuiz ? "Update Quiz" : "Save Quiz"}
//                 </button>
//                 {editingQuiz && (
//                     <button
//                         type="button"
//                         onClick={resetForm}
//                         className="bg-gray-500 text-white px-4 py-2 rounded ml-2"
//                     >
//                         Cancel
//                     </button>
//                 )}
//             </form>
//         </div>
//     );
// };

// export default QuizManager;



// // import React, { useState } from "react";
// // import { addDoc, collection } from "firebase/firestore";
// // import { ref, getDownloadURL, uploadBytesResumable } from "firebase/storage";
// // import db, { storage } from "./Firebase";
// // import { doc, setDoc, getDocs } from "firebase/firestore";

// // const AddQuiz = () => {
// //     const [customDocId, setCustomDocId] = useState(""); // Custom doc ID
// //     const [quizData, setQuizData] = useState([
// //         {
// //             question: "",
// //             answers: ["", "", "", ""],
// //             correctAnswer: 0,
// //             selectedAnswer: null,
// //         },
// //     ]);

// //     // Handle changes in custom document ID input
// //     const handleCustomDocIdChange = (e) => {
// //         setCustomDocId(e.target.value);
// //     };

// //     // Handle changes in question inputs
// //     const handleQuestionChange = (index, value) => {
// //         const updatedQuizData = [...quizData];
// //         updatedQuizData[index].question = value;
// //         setQuizData(updatedQuizData);
// //     };

// //     // Handle changes in answer inputs
// //     const handleAnswerChange = (qIndex, aIndex, value) => {
// //         const updatedQuizData = [...quizData];
// //         updatedQuizData[qIndex].answers[aIndex] = value;
// //         setQuizData(updatedQuizData);
// //     };

// //     // Handle correct answer selection
// //     const handleCorrectAnswerChange = (index, value) => {
// //         const updatedQuizData = [...quizData];
// //         updatedQuizData[index].correctAnswer = parseInt(value);
// //         setQuizData(updatedQuizData);
// //     };

// //     // Add a new question field
// //     const addQuestion = () => {
// //         setQuizData([
// //             ...quizData,
// //             {
// //                 question: "",
// //                 answers: ["", "", "", ""],
// //                 correctAnswer: 0,
// //                 selectedAnswer: null,
// //             },
// //         ]);
// //     };


// //     // Handle form submission
// //     const handleSubmit = async (e) => {
// //         e.preventDefault();

// //         const formattedData = {
// //             questions: quizData,
// //         };

// //         try {
// //             // await addDoc(collection(db, "nv_quiz_data"), formattedData);
// //             await setDoc(doc(db, 'nv_quiz_data', customDocId), formattedData);
// //             alert("Quiz data saved successfully!");
// //             setQuizData([
// //                 {
// //                     question: "",
// //                     answers: ["", "", "", ""],
// //                     correctAnswer: 0,
// //                     selectedAnswer: null,
// //                 },
// //             ]);
// //         } catch (error) {
// //             console.error("Error saving quiz data:", error);
// //             alert("Failed to save quiz data.");
// //         }
// //     };



// //     return (
// //         <div style={{ maxWidth: "600px", margin: "0 auto", padding: "20px" }}>
// //             <h2>Add Quiz Questions</h2>
// //             <form onSubmit={handleSubmit}>
// //                 <label>Quiz ID:</label>
// //                 <input
// //                     type="text"
// //                     value={customDocId}
// //                     onChange={handleCustomDocIdChange}
// //                     required
// //                     placeholder="Enter quiz ID (e.g., q1,q2 and so on)"
// //                     style={{ width: "100%", padding: "10px", marginBottom: "20px" }}
// //                 />

// //                 {quizData.map((quiz, qIndex) => (
// //                     <div key={qIndex} style={{ marginBottom: "20px", border: "1px solid #ccc", padding: "10px" }}>
// //                         <label>Question {qIndex + 1}:</label>
// //                         <input
// //                             type="text"
// //                             value={quiz.question}
// //                             onChange={(e) => handleQuestionChange(qIndex, e.target.value)}
// //                             required
// //                             style={{ width: "100%", padding: "10px", marginBottom: "10px" }}
// //                         />
// //                         <label>Answers:</label>
// //                         {quiz.answers.map((answer, aIndex) => (
// //                             <div key={aIndex}>
// //                                 <input
// //                                     type="text"
// //                                     value={answer}
// //                                     onChange={(e) => handleAnswerChange(qIndex, aIndex, e.target.value)}
// //                                     required
// //                                     style={{ width: "100%", padding: "10px", marginBottom: "10px" }}
// //                                     placeholder={`Option ${String.fromCharCode(65 + aIndex)}`}
// //                                 />
// //                             </div>
// //                         ))}
// //                         <label>Correct Answer (eg. 1, 2, 3, 4):</label>
// //                         {/* <input
// //                             type="number"
// //                             value={quiz.correctAnswer}
// //                             onChange={(e) => handleCorrectAnswerChange(qIndex, e.target.value)}
// //                             required
// //                             min="0"
// //                             max={quiz.answers.length - 1}
// //                             style={{ width: "100%", padding: "10px", marginBottom: "10px" }}
// //                         /> */}

// //                         <input
// //                             type="number"
// //                             value={quiz.correctAnswer + 1}  // Display value adjusted to be 1-based
// //                             onChange={(e) => handleCorrectAnswerChange(qIndex, parseInt(e.target.value) - 1)}
// //                             required
// //                             min="1"
// //                             max={quiz.answers.length}
// //                             style={{ width: "100%", padding: "10px", marginBottom: "10px" }}
// //                         />
// //                     </div>
// //                 ))}
// //                 <button type="button" onClick={addQuestion} style={{ marginRight: "10px", padding: "10px 20px" }}>
// //                     Add Another Question
// //                 </button>
// //                 <button type="submit" style={{ padding: "10px 20px" }}>Save Quiz</button>
// //             </form>
// //         </div>
// //     );
// // };

// // export default AddQuiz;